import { Platform } from "@ionic/angular";
import { Injectable, Injector } from "@angular/core";
 
 
import {AFConstants, AFEvent, AFInit, AFUid, AppsFlyer} from 'appsflyer-capacitor-plugin';
import {AdvertisingId} from "@capacitor-community/advertising-id";

import {
  AffiliateTrackerInterface,
  AffiliateTrackerCallbackParams,
} from "../../interfaces/affliation-interface";
// import { cordovaWarn } from "@ionic-native/core";
// import { MainProvider } from "../../modules/lobby/providers/main.provider";
// import { DeeplinkProvider } from "./deeplink-provider";
import { EventsService } from "../event/event.service";
import { ConfigService } from "../config/config.service";
import { animationFrameScheduler } from "rxjs";
import { RedirectService } from "../redirect/redirect.service";
import { NotificationHandlerService } from "../notification-handler/notification-handler.service";


declare var window: any;

export interface TrackingIDsInterface {
  deviceDetails: string,
  externalSource: string
}

@Injectable({
  providedIn: "root",
})
export class AppsflyerService implements AffiliateTrackerInterface {
  private configVars: any;
  private attributionData: any = null;
  private shouldAnonymizeUser: boolean = false;
  private ios_strategies = {
    DEFAULT: this.iosStrategyAllowDeny,
    "ALLOW-DENY": this.iosStrategyAllowDeny,
    MINIMAL: this.iosStrategyMinimal,
  };
  private appsFlyerEventID: any = null;
  private IDFA:string = null;
  private appsFlyerID: string = null;
  deepLink;
  public trackStatus;
  constructor(
    protected platform: Platform,
    protected injector: Injector,
    protected notificationHandler: NotificationHandlerService,
    protected config: ConfigService // protected device: Device, // protected appsflyer: AppsFlyer, // protected events: EventsService,
  ) // protected mainProvider: MainProvider,
  // protected deeplinkProvider: DeeplinkProvider
  {
    this.config.isLoaded().then(() => {
      this.configVars = this.config.getConfig();
      this.deepLink = injector.get(RedirectService);
    });

    // //Adding IAB specific calls to capture AppsFlyer Event
    // this.events.subscribe("event:IAB:AppsFlyer", (val) => {
    //   if (this.appsFlyerEventID !== val.dataToSend.transaction_id) {
    //     console.log("-------APPS FLYER Event-------", val.appsFlyerEvent);
    //     console.log("-------APPS FLYER Value-------", val.dataToSend);
    //     window.plugins.appsFlyer.logEvent(val.appsFlyerEvent, val.dataToSend);
    //     this.appsFlyerEventID = val.dataToSend.transaction_id;
    //   }
    // });
  }
  initialize(): Promise<AffiliateTrackerInterface> {
    const mythis = this;
    return new Promise((resolve_tracker, reject_tracker) => {
      Promise.all([this.platform.ready(), this.config.isLoaded()]).then(
        ([ready, _notused]) => {
          var config = this.config.getConfig();

          console.log("AF: AppsFlyer: ***** INITIALIZING *****");
          console.log("AF: appsflyer.ts: config: ", config);
          var options: any = {
            devKey: config.FEATURE_APPSFLYER_DEVKEY,
            onInstallConversionDataListener: true,
          };
          options.isDebug =
            config.FEATURE_APPSFLYER_DEBUG &&
            config.FEATURE_APPSFLYER_DEBUG == "1";
          // DeepLinking set up
          // window.plugins.appsFlyer
          //   .registerOnAppOpenAttribution
            // (res) => {
            //   console.log(res);
            //   var deeplinkData = JSON.parse(res);
            //v this.deeplinkProvider.processDeeplink(deeplinkData);
            //   if( deeplinkData.data && deeplinkData.data.host == 'popupbridgev1') {
            //     console.log( 'detected popupbridge deeplink, dont send use it in Appsflyer!');

            //   } else if(deeplinkData.type === 'onAppOpenAttribution'){
            //     const deepLinkValue: string = deeplinkData.data.deep_link_value;
            //     const deeplinkSub1:string = ('deep_link_sub1' in deeplinkData.data)? deeplinkData.data.deep_link_sub1 : "";

            //     // redirect here
            //      mythis.redirectProvider.navigateBasedOnPathName(deepLinkValue, deeplinkSub1);
            //   } else {
            //     console.log('onAppOpenAttribution error');
            //   }
            // },
            // function onAppOpenAttributionError(err) {
            //   console.log(err);
            // }
            // ();
            this.setConversions();

          if (this.platform.is("ios")) {
            options.appID = config.FEATURE_APPSFLYER_IOS_APPID; // iOS app store id
            // if FEATURE_APPSFLYER_IOS_STRATEGY === 'IDFA' OTHER VALUES 'SKADNETWORK'

            var strategy =
              this.ios_strategies[config.FEATURE_APPSFLYER_IOS_STRATEGY];

            if (!strategy) {
              strategy = this.ios_strategies["DEFAULT"];
            }
            console.log("AF: Appsflyer IOS")
            strategy
              .apply(this, [config, options])
              .then(() => {
                resolve_tracker(this);
              })
              .catch((e) => {
                reject_tracker(e);
              });
          } else if (this.platform.is("android")) {
            //Do not log sensitive data due to security reason
            // console.log("AF: appsflyer.ts: initSDK Android");
            // console.log("AF: appsFlyer.ts: options:", JSON.stringify(options));
            const appsflyerData = localStorage.getItem('appsFlyer_initWasSuccessful');
            if (appsflyerData && appsflyerData != null) {
              const storedAppsflyerObj = JSON.parse(appsflyerData);
              this.IDFA = storedAppsflyerObj.idfa;
              this.appsFlyerID = storedAppsflyerObj.appsFlyerID;
            }
            this.appsflyerInitSDK(options).then( () => {              
               if(!appsflyerData || appsflyerData == null) {
                AdvertisingId.getAdvertisingId()
                  .then( (value => {
                    // console.log( 'AF: advertising-id: value='+JSON.stringify( value));
                    this.IDFA = value.id;
                  }))
                this.getAppsFlyerID()
                  .then( (value) => {
                    // console.log( 'AF: appsflyerId: value='+JSON.stringify( value));
                    this.appsFlyerID = value.uid
                    this.storeAppsflyerData();
                  })
              }
            }).then(() => {
              resolve_tracker(this);
            }).catch((e) => {
              reject_tracker(e);
            });
          }
        }
      );
    });
  }

  storeAppsflyerData() {
    if(this.appsFlyerID) {
      const appsflyerObj = {
        idfa: this.IDFA,
        appsFlyerID: this.appsFlyerID
      }
      localStorage.setItem('appsFlyer_initWasSuccessful', JSON.stringify(appsflyerObj));
    }
  }

  getStoredAppsflyerData() {
      var storedAppsflyerObj
      const appsflyerData = localStorage.getItem('appsFlyer_initWasSuccessful');
      if (appsflyerData && appsflyerData != null) {
         storedAppsflyerObj = JSON.parse(appsflyerData);
         this.IDFA = storedAppsflyerObj.idfa;
         this.appsFlyerID = storedAppsflyerObj.appsFlyerID;
      }
      return storedAppsflyerObj;
  }

  appsflyerInitSDK(options): Promise<boolean> {
    return new Promise((resolve, reject) => {
      this.setOAOA();

      if(this.shouldAnonymizeUser) {
        AppsFlyer.anonymizeUser({anonymizeUser: true});
      }
      
      options.minTimeBetweenSessions = 1;
      options.registerOnAppOpenAttribution = true;
      return AppsFlyer.initSDK(options)
            .then((res) => {
              console.log('AF: SUCCESS: '+JSON.stringify(res));
              resolve(true);
            })
    });
  }

  public getTrackingIDs(): TrackingIDsInterface {
    return {
      externalSource: this.appsFlyerID,
      deviceDetails: this.IDFA
    };
  }

  // set a listener
  setConversions() {
    AppsFlyer.addListener(AFConstants.CONVERSION_CALLBACK, (event) => {
      if ("undefined" !== typeof event.data
          && event.data.is_first_launch
          ) {
        console.log("appsFlyer.ts: attribution_data", event.data);
        this.attributionData = event.data;
      }

      if (event.callbackName === AFConstants.onConversionDataSuccess) {
        if (event.data.af_status === "Non-organic") {
          if (event.data.is_first_launch === true) {
            const deepLinkValue = event.data.deep_link_value;
            this.handleLink(deepLinkValue);
          }
        }
      }
    });
  }

  getAttributionData(): Promise<any> {
      return Promise.resolve({
        appsflyer: this.attributionData
      });
  }

  handleLink(deepLinkPath: any, deepLinkSub1?: any) {
    console.log('AF: '+deepLinkPath, deepLinkSub1);
    //const deepLinkValue1: string = deepLinkData.data.deep_link_value;
    //const deepLinkSub11: string = ('deep_link_sub1' in deepLinkData.data) ? deepLinkData.data.deep_link_sub1 : "";
      //Setting a 7-second timeout to complete the landing screen.
      this.notificationHandler.isSplashScreenFinished$.subscribe((isFinished) => {  
        if(isFinished) {
          this.deepLink.deepLinkActionForAppsFlyer(deepLinkPath, deepLinkSub1);  
        }
      });    
  }

  setUDL() {
    AppsFlyer.addListener(AFConstants.UDL_CALLBACK, (res) => {
      alert("UDL_CALLBACK ~~>" + JSON.stringify(res));
      if (res.status === "FOUND") {
        const deepLinkValue = res.deepLink.deep_link_value;
        this.handleLink(deepLinkValue);
      } else if (res.status === "ERROR") {
        console.log("AF: udl error: " + res.error);
      }
    });

    // AppsFlyer.addListener(AFConstants.UDL_CALLBACK, res => {
    //   alert('UDL_CALLBACK ~~>' + JSON.stringify(res));
    //   if (res.status === 'FOUND') {
    //     console.log('deep link found');
    //   } else if (res.status === 'ERROR') {
    //     console.log('deep link error');
    //   } else {
    //     console.log('deep link not found');
    //   }
    // });
  }

  // set a listener
  setOAOA() {
    AppsFlyer.addListener(AFConstants.OAOA_CALLBACK, (res) => {
      
      if (res.callbackName === AFConstants.onAppOpenAttribution) {
        //const deepLinkValue = res.data.deep_link_value;
        //Addition Deep Link value which we can use to determine state value to trigger the deeplink based on state
        //console.log(res.data.deep_link_sub1);
        const deepLinkValue1: string = res.data.deep_link_value;
        const deepLinkSub1: string = ('deep_link_sub1' in res.data) ? res.data.deep_link_sub1 : "";
        this.handleLink(deepLinkValue1, deepLinkSub1)
      } else {
        console.log('AF: '+res.errorMessage);
      }
    });
  }

  logEvent() {
    const data: AFEvent = {
      eventName: "test",
      eventValue: {
        af_revenue: 956,
        af_receipt_id: "id536",
        af_currency: "USD",
      },
    };
    AppsFlyer.logEvent(data)
      .then((r) => alert("logEvent ~~>" + r.res))
      .catch((err) => alert("logEvent err ~~>" + err));
  }

  brandedDomains() {
    AppsFlyer.setOneLinkCustomDomain({ domains: ["af", "lavi", "aaa"] });
    this.myLogger("brandedDomains");
  }

  resolveDeepLinksUrls() {
    AppsFlyer.setResolveDeepLinkURLs({ urls: ["af", "apps", "appsflyer"] });
    this.myLogger("ResolveDeepLinksUrls");
  }

  getSDKVersion() {
    AppsFlyer.getSdkVersion().then((v) => alert("SDK Version: " + v.res));
  }

  myLogger(msg: string) {
    console.log("Paz_logger: " + msg);
  }

  getAppsFlyerID(): Promise<AFUid> {
    return AppsFlyer.getAppsFlyerUID();
  }

  generateInviteLink() {
    AppsFlyer.generateInviteLink({
      addParameters: { code: "1256abc", page: "152" },
      campaign: "appsflyer_plugin",
      channel: "sms",
    })
      .then((r) => alert("user invite link: " + r.link))
      .catch((e) => alert("user invite error: " + e));
  }

  validateAndLogInAppPurchase() {
    if (this.platform.is("android")) {
      AppsFlyer.validateAndLogInAppPurchaseAndroid({
        additionalParameters: { aa: "cc" },
        currency: "usd",
        price: "20",
        signature: "the_signature",
        publicKey: "your_public_key",
        purchaseData: "the_purchase_data",
      })
        .then((r) => alert("validateAndLogInAppPurchase success: " + r.res))
        .catch((e) => alert("validateAndLogInAppPurchase error: " + e));
    } else if (this.platform.is("ios")) {
      AppsFlyer.validateAndLogInAppPurchaseIos({
        additionalParameters: { aa: "cc" },
        currency: "usd",
        price: "20",
        inAppPurchase: "productIdentifier",
        transactionId: "transactionId",
      })
        .then((r) => alert("validateAndLogInAppPurchase success: " + r.res))
        .catch((e) =>
          alert("validateAndLogInAppPurchase error: " + JSON.stringify(e))
        );
    }
  }

  // setSharingFilterForAllPartners() {
  //   AppsFlyer.setSharingFilterForAllPartners();
  // }

  // setSharingFilter() {
  //   AppsFlyer.setSharingFilter({ filters: ["google_int"] });
  // }

  anonymizeUser() {
    AppsFlyer.anonymizeUser({ anonymizeUser: true });
  }

  stop() {
    AppsFlyer.stop().then((res) => {
      //return current state
      AppsFlyer.stop({ stop: !res.isStopped }) //change state
        .then((r) => alert("isStopped: " + r.isStopped)); //show state after change
    });
  }

  // sendPushNotificationData() {
  //   AppsFlyer.sendPushNotificationData({
  //     pushPayload: {
  //       af: '{"pid":"media_int","is_retargeting":"true", "c":"test_campaign"}',
  //     }, //replace with push payload
  //   });
  // }

  private runAppsFlyerAPIs() {
    //AppsFlyer.setHost({hostName:'af',hostPrefixName:'cn'});
    //AppsFlyer.disableAdvertisingIdentifier({shouldDisable:true});
    //AppsFlyer.disableCollectASA({shouldDisable:true});
    //AppsFlyer.disableSKAdNetwork({shouldDisable:true});
    AppsFlyer.setCurrentDeviceLanguage({ language: "en" })
      .then((res) => console.log('AF: '+res.res))
      .catch((e) => console.log('AF: '+e));
    AppsFlyer.setAppInviteOneLink({ onelinkID: "your_onelink_id" }).then();
    AppsFlyer.setCustomerUserId({ cuid: "csadadadad" });
    AppsFlyer.setCurrencyCode({ currencyCode: "ILS" });
    AppsFlyer.updateServerUninstallToken({ token: "fdsffddfbnjdfoiuvhof" });
    AppsFlyer.setOneLinkCustomDomain({
      domains: [
        "promotion.greatapp.com",
        "click.greatapp.com",
        "deals.greatapp.com",
      ],
    });
    AppsFlyer.appendParametersToDeepLinkingURL({
      contains: "paz",
      parameters: {
        is_retargeting: "true", //Required
        pid: "cap_app", //Required
        my_param: "xyz",
      },
    });
    AppsFlyer.setResolveDeepLinkURLs({ urls: ["af", "appsflyer"] });
    AppsFlyer.addPushNotificationDeepLinkPath({ path: ["paz", "a", "b"] });
    AppsFlyer.setAdditionalData({
      additionalData: {
        capacitor: "plugin",
        apps: "Flyer",
      },
    });

    //   AppsFlyer.enableFacebookDeferredApplinks({enableFacebookDAL: true})
    //     .then(res => alert(res.res))
    //     .catch(e => alert(e));
    //
  }

  // protected getIDFAInfo(): Promise<any> {
  //   var cordova: any;
  //   if ((cordova = window["cordova"]) && cordova.plugins.idfa) {
  //     const idfaPlugin = cordova.plugins.idfa;
  //     return idfaPlugin.getInfo().then((info) => {
  //       // if (!info.trackingLimited) {
  //       //     return info.idfa || info.aaid;
  //       // } else
  //       if (
  //         info.trackingPermission ===
  //           idfaPlugin.TRACKING_PERMISSION_NOT_DETERMINED ||
  //         info.trackingPermission === idfaPlugin.TRACKING_PERMISSION_DENIED
  //       ) {
  //         // ask for permission first
  //         return idfaPlugin.requestPermission().then((result) => {
  //           if (result === idfaPlugin.TRACKING_PERMISSION_AUTHORIZED) {
  //             return idfaPlugin.getInfo().then((info) => {
  //               return info.idfa || info.aaid;
  //             });
  //           } else {
  //             return Promise.resolve(null);
  //           }
  //         });
  //       } else if (
  //         info.trackingPermission === idfaPlugin.TRACKING_PERMISSION_AUTHORIZED
  //       ) {
  //         // just get the data
  //         idfaPlugin.getInfo().then((info) => {
  //           return info.idfa || info.aaid;
  //         });
  //       } else {
  //         // we are not allowing it
  //         return Promise.resolve(null);
  //       }
  //     });
  //   } else {
  //     // no cordova plugin, succeed with no identifier
  //     return Promise.resolve(null);
  //   }
  // }

  // protected appsflyerInitSDK(options): Promise<any> {
  //   return new Promise((resolve, reject) => {
  //     var initWasSuccessful = window.sessionStorage.getItem(
  //       "appsFlyer_initWasSuccessful"
  //     );
  //     if (initWasSuccessful === "true") {
  //       resolve(this);
  //     } else {
  //       var mythis = this; // weird initSdk callback seems to kill 'this' in below block
  //       window.plugins.appsFlyer.initSdk(
  //         options,
  //         (result) => {
  //           if (mythis.shouldAnonymizeUser) {
  //             window.plugins.appsFlyer.anonymizeUser(true);
  //           }
  //           let attr_obj = JSON.parse(result);
  //           if (
  //             "undefined" !== typeof attr_obj.data &&
  //             attr_obj.status == "success" &&
  //             attr_obj.data.is_first_launch
  //           ) {
  //             console.log(
  //               "appsFlyer.ts: attribution_data",
  //               JSON.stringify(attr_obj.data)
  //             );
  //             mythis.attributionData = attr_obj.data;
  //           }
  //           this.appsflyer.getAppsFlyerUID().then((data) => {
  //             mythis.appsflyer_id = data;
  //           });
  //           window.sessionStorage.setItem(
  //             "appsFlyer_initWasSuccessful",
  //             "true"
  //           );
  //           resolve(mythis);
  //         },
  //         (error: any) => {
  //           console.log("initSdk: error: ", error);
  //           reject(error);
  //         }
  //       );
  //     }
  //   });
  // }

  // protected iosStrategyDefault(config, options): Promise<any> {
  //   console.log("appsflyer.ts:: AppsFlyer strategy: DEFAULT");
  //   return Promise.reject("FEATURE_APPSFLYER_IOS_STRATEGY not configured");
  // }

  protected iosStrategyAllowDeny(config, options): Promise<any> {
    console.log("AF: appsflyer.ts:: AppsFlyer strategy: ALLOW-DENY");
    const waitTime = this.config.getConfig().FEATURE_IOS_ATT_TIMEOUT ?? 60;
    options.waitForATTUserAuthorization = Number(waitTime);
    // return this.getIDFAInfo().then((idfaInfo) => {
    //   if (!idfaInfo) {
    //     this.shouldAnonymizeUser = true;
    //   }
    //   console.log("appsflyer.ts: initSDK iOS");
    //   console.log("appsFlyer.ts: idfaInfo:", JSON.stringify(idfaInfo));
    //   console.log("appsFlyer.ts: options:", JSON.stringify(options));
    return AdvertisingId.getAdvertisingStatus()
        .then((res) => {
          this.trackStatus = res
          if (res.status === 'Denied' || res.status === 'Restricted') {
            this.shouldAnonymizeUser = true;
          }     
          //Do not log sensitive data due to security reason     
          // console.log("AF: ATT status: ", res)
          // console.log("AF: Appsflyer initSDK", options);
          const appsflyerData = localStorage.getItem('appsFlyer_initWasSuccessful');
          if (appsflyerData && appsflyerData != null) {
            const storedAppsflyerObj = JSON.parse(appsflyerData);
            this.IDFA = storedAppsflyerObj.idfa;
            this.appsFlyerID = storedAppsflyerObj.appsFlyerID;
          }
          return this.appsflyerInitSDK(options)
            .then( () => {
              if(!appsflyerData || appsflyerData == null) {
                AdvertisingId.getAdvertisingId()
                  .then( (value => {
                    // console.log( 'AF: advertising-id: value='+JSON.stringify( value));
                    this.IDFA = value.id;
                  }))
                this.getAppsFlyerID()
                  .then( (value) => {
                    // console.log( 'AF: appsflyerId: value='+JSON.stringify( value));
                    this.appsFlyerID = value.uid
                    this.storeAppsflyerData();
                  })
              }
          })
          .catch( (e) => alert("failed to initialize appsflyer: "+e));
      });
  }

  public loadAndStoredTrackingIDs() {
    return new Promise(async (resolve, reject) => {
      try {
        const trackId = await AdvertisingId.getAdvertisingId();
        console.log('AF: advertising-id: value=' + JSON.stringify(trackId));
        this.IDFA = trackId.id;
        const value = await this.getAppsFlyerID();
        console.log('AF: appsflyerId: value=' + JSON.stringify(value));
        this.appsFlyerID = value.uid
        this.storeAppsflyerData();
        resolve(true);
      } catch (e) { 
        resolve(false); 
        console.error(e) }
    })
  }

  protected iosStrategyMinimal(config, options): Promise<any> {
    console.log("AF: appsflyer.ts:: AppsFlyer strategy: MINIMAL");
    console.log("AF: setting waitForATTUserAuthorization = 60");
    options.waitForATTUserAuthorization = 60;
    console.log("AF: appsflyer.ts: initSDK iOS");
    console.log("AF: appsFlyer.ts: options:", JSON.stringify(options));
    return this.appsflyerInitSDK(options)
    .then( () => true)
    .catch( (e) => alert("failed to initialize appsflyer: "+e));
}

  // initialize(): Promise<AffiliateTrackerInterface> {
  //   const mythis = this;
  //   return new Promise((resolve_tracker, reject_tracker) => {
  //     Promise.all([this.platform.ready(), this.config.isLoaded()]).then(
  //       ([ready, _notused]) => {
  //         var config = this.config.getConfig();

  //         console.log("AppsFlyer: ***** INITIALIZING *****");
  //         console.log("appsflyer.ts: config: ", config);
  //         var options: any = {
  //           devKey: config.FEATURE_APPSFLYER_DEVKEY,
  //           onInstallConversionDataListener: true,
  //         };
  //         options.isDebug =
  //           config.FEATURE_APPSFLYER_DEBUG &&
  //           config.FEATURE_APPSFLYER_DEBUG == "1";
  //         // DeepLinking set up
  //         window.plugins.appsFlyer.registerOnAppOpenAttribution(
  //           (res) => {
  //             console.log(res);
  //             var deeplinkData = JSON.parse(res);
  //             //v this.deeplinkProvider.processDeeplink(deeplinkData);
  //             //   if( deeplinkData.data && deeplinkData.data.host == 'popupbridgev1') {
  //             //     console.log( 'detected popupbridge deeplink, dont send use it in Appsflyer!');

  //             //   } else if(deeplinkData.type === 'onAppOpenAttribution'){
  //             //     const deepLinkValue: string = deeplinkData.data.deep_link_value;
  //             //     const deeplinkSub1:string = ('deep_link_sub1' in deeplinkData.data)? deeplinkData.data.deep_link_sub1 : "";

  //             //     // redirect here
  //             //      mythis.redirectProvider.navigateBasedOnPathName(deepLinkValue, deeplinkSub1);
  //             //   } else {
  //             //     console.log('onAppOpenAttribution error');
  //             //   }
  //           // },
  //           function onAppOpenAttributionError(err) {
  //             console.log(err);
  //           }
  //         );

  //         if (this.platform.is("ios")) {
  //           options.appId = config.FEATURE_APPSFLYER_IOS_APPID; // iOS app store id
  //           // if FEATURE_APPSFLYER_IOS_STRATEGY === 'IDFA' OTHER VALUES 'SKADNETWORK'

  //           var strategy =
  //             this.ios_strategies[config.FEATURE_APPSFLYER_IOS_STRATEGY];

  //           if (!strategy) {
  //             strategy = this.ios_strategies["DEFAULT"];
  //           }

  //           strategy
  //             .apply(this, [config, options])
  //             .then(() => {
  //               resolve_tracker(this);
  //             })
  //             .catch((e) => {
  //               reject_tracker(e);
  //             });
  //         } else if (this.platform.is("android")) {
  //           console.log("appsflyer.ts: initSDK Android");
  //           console.log("appsFlyer.ts: options:", JSON.stringify(options));
  //           this.appsflyerInitSDK(options)
  //             .then(() => {
  //               resolve_tracker(this);
  //             })
  //             .catch((e) => {
  //               reject_tracker(e);
  //             });
  //         }
  //       }
  //     );
  //   });
  // }

  // signupStep1Complete(cbParams: AffiliateTrackerCallbackParams) {
  //   console.log("appsflyer.ts: event: signupStep1Complete", cbParams);
  //   let af_params: AFEvent = cbParams as AFEvent;
  //   window.plugins.appsFlyer.logEvent("signup_step1_complete", af_params);
  // }
  // signupComplete(cbParams: AffiliateTrackerCallbackParams) {
  //   if (cbParams.customer_id) {
  //     this.appsflyer.setAppUserId(cbParams.customer_id.toString());
  //   }
  //   console.log("appsflyer.ts: event: signupComplete", cbParams);
  //   let af_params: AFEvent = cbParams as AFEvent;
  //   window.plugins.appsFlyer.logEvent("signup_complete", af_params);
  // }

  // deposit(cbParams: AffiliateTrackerCallbackParams) {
  //   console.log("appsflyer.ts: event: deposit", cbParams);
  //   let af_params: AFEvent = cbParams as AFEvent;

  //   if (
  //     "undefined" !== typeof cbParams.amount &&
  //     "undefined" === typeof af_params["af_revenue"]
  //   ) {
  //     af_params["af_revenue"] = cbParams.amount;
  //   }
  //   window.plugins.appsFlyer.logEvent("deposit", af_params);
  // }

  // withdraw(cbParams: AffiliateTrackerCallbackParams) {
  //   console.log("appsflyer.ts: event: withdraw", cbParams);
  //   let af_params: AFEvent = cbParams as AFEvent;

  //   if (
  //     "undefined" !== typeof cbParams.amount &&
  //     "undefined" === typeof af_params["af_revenue"]
  //   ) {
  //     af_params["af_revenue"] = -cbParams.amount;
  //   }
  //   window.plugins.appsFlyer.logEvent("withdraw", af_params);
  // }

  // login(cbParams: AffiliateTrackerCallbackParams) {
  //   console.log("appsflyer.ts: event: client connection ping", cbParams);
    
  //   this.clientPing();
  // }

  clientPing() {
    const data: AFEvent = {
      eventName: "client_connection_ping",
      eventValue: {
        ok: 1
      }
    };
    AppsFlyer.logEvent(data)
      .then((r) => console.log('AF: logEvent', r))
      .catch((err) => console.log('AF: logEvent', err));
  }

  // gameLaunched(cbParams: AffiliateTrackerCallbackParams) {
  //   console.log("appsflyer.ts: event: gameLaunched", cbParams);
  //   let af_params: AFEvent = cbParams as AFEvent;
  //   window.plugins.appsFlyer.logEvent("game_launched", af_params);
  // }
}
